import React, { useEffect } from 'react';
import StoreItem from './StoreItem';

const StoreList = (props) => {

    const deg2rad = (deg) => {
        return deg * (Math.PI / 180);
    };

    const calculateDistance = (lat1, lon1, lat2, lon2) => {
        // this can be done in the api, but it wasn't working so this calculates the distance between two points on a globe
        let R = 6371;
        let dLat = deg2rad(lat2 - lat1);
        let dLon = deg2rad(lon2 - lon1);
        let a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
        let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        let d = R * c;
        d = Math.round(d * 100) / 100;
        return d;
    };

    const milesOnMap = () => {
        // calculate how many miles are on the map
        const a = 810 / Math.pow((1 / 810), (3 / 5));
        const b = Math.pow((1 / 810), (1 / 10));
        return (a * Math.pow(b, props.currentZoom)).toFixed(2);
    };

    const renderStoreItem = () => {
        if (props.stores) {
            const centerLat = props.currentLocation.substring(0, props.currentLocation.indexOf(","));
            const centerLng = props.currentLocation.substring(props.currentLocation.indexOf(",") + 1, props.currentLocation.length);
            const storesToObject = Object.entries(props.stores);
            const distanceStoreData = storesToObject.map(store => ({ ...store }))
                .sort((b, a) => calculateDistance(b[1].latitude, b[1].longitude, centerLat, centerLng) - calculateDistance(a[1].latitude, a[1].longitude, centerLat, centerLng))
                .filter((store => milesOnMap() > calculateDistance(store[1].latitude, store[1].longitude, centerLat, centerLng)));
            if (distanceStoreData.length == 0) {
                return (<div> <p>No Stores Found</p></div>)
            } else {
                return (
                    <div> {distanceStoreData.map((store) => (
                        <StoreItem store={store} key={props.key} distance={calculateDistance(store[1].latitude, store[1].longitude, centerLat, centerLng)} />))}
                    </div>
                )
            }
        }
    };

    return (
        <div>{renderStoreItem()}</div>
    );
}

export default StoreList;